import React from "react";
import { Modal, Image } from "react-bootstrap";
import { checkEmptyOrNull, hasRole } from "../Utils";
import Loader from "./Loader";
import "../../pages/Users/MemberViewModal.css";

const MemberDetailsModal = ({
  show,
  onHide,
  detailData = {},
  loading = false,
}) => {
  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onHide}
      backdrop="static"
      dialogClassName="member-view-modal"
      className="modal-glass"
      contentClassName="member-view-modal-content"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Member Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <Loader loading={loading} />
        ) : (
          <>
            <div className="member-view-avatar-wrap">
              <Image
                src={detailData?.profile_image || "/profile-default.png"}
                className="member-view-avatar"
                alt={detailData?.name || "Member"}
              />
              {detailData?.membership_status_text && (
                <span
                  className={`member-view-status-badge ${
                    String(detailData.membership_status_text)
                      .toLowerCase()
                      .includes("active")
                      ? "badge-status-active"
                      : String(detailData.membership_status_text)
                            .toLowerCase()
                            .includes("expir")
                        ? "badge-status-expired"
                        : "badge-status-pending"
                  }`}
                >
                  {detailData.membership_status_text}
                </span>
              )}
            </div>
            <h5 className="member-view-name">
              {checkEmptyOrNull(detailData.name)}
            </h5>
            <p className="member-view-id">
              {checkEmptyOrNull(detailData.member_id)}
            </p>

            <div className="member-view-details-card">
              <div className="member-view-grid">
                <div className="member-view-field">
                  <span className="member-view-label">Email:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.email)}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">Mobile:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.mobile_number)}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">WhatsApp:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.whatsapp_mobile_number)}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">Company:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.company_name)}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">Date of Birth:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.dob)}
                  </span>
                </div>
                <div className="member-view-field member-view-field--full">
                  <span className="member-view-label">Address:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.address)}
                  </span>
                </div>
                <div className="member-view-field member-view-field--full">
                  <span className="member-view-label">Bio:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.bio_description)}
                  </span>
                </div>
                <div className="member-view-field member-view-field--full">
                  <span className="member-view-label">
                    Products &amp; Services:
                  </span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.our_products_and_services)}
                  </span>
                </div>

                {hasRole([1]) && (
                  <div className="member-view-field">
                    <span className="member-view-label">Country:</span>
                    <span className="member-view-value">
                      {checkEmptyOrNull(detailData.country_name)}
                    </span>
                  </div>
                )}
                {hasRole([1, 6]) && (
                  <div className="member-view-field">
                    <span className="member-view-label">State:</span>
                    <span className="member-view-value">
                      {checkEmptyOrNull(detailData.state_name)}
                    </span>
                  </div>
                )}
                {hasRole([1, 6, 7]) && (
                  <div className="member-view-field">
                    <span className="member-view-label">Region:</span>
                    <span className="member-view-value">
                      {checkEmptyOrNull(detailData.region_name)}
                    </span>
                  </div>
                )}
                {hasRole([1, 6, 7, 2]) && (
                  <div className="member-view-field">
                    <span className="member-view-label">Chapter:</span>
                    <span className="member-view-value">
                      {checkEmptyOrNull(detailData.chapter_name)}
                    </span>
                  </div>
                )}

                <div className="member-view-field">
                  <span className="member-view-label">User Role:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.user_role_name)}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">Category:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.category_name)}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">Member Crowns:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.crowns_name)}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">Date of Joining:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.date_of_joining)}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">Membership Due:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.membership_due_date)}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">Blood Group:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.blood_group_name)}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">GST Number:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.gst)}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">Website:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.website)}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">Instagram Personal:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(
                      detailData.instagram_personal_profile_link,
                    )}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">Instagram Business:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(
                      detailData.instagram_business_profile_link,
                    )}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">LinkedIn:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.linkedin_url)}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">Twitter:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.twitter_url)}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">YouTube:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.youtube_url)}
                  </span>
                </div>
                <div className="member-view-field">
                  <span className="member-view-label">Referred By:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.referred_by_text)}
                  </span>
                </div>

                {detailData.referred_by === 3 && (
                  <>
                    <div className="member-view-field">
                      <span className="member-view-label">Referrer Name:</span>
                      <span className="member-view-value">
                        {checkEmptyOrNull(detailData.referrer_name)}
                      </span>
                    </div>
                    <div className="member-view-field">
                      <span className="member-view-label">
                        Referrer Mobile:
                      </span>
                      <span className="member-view-value">
                        {checkEmptyOrNull(detailData.referrer_mobile)}
                      </span>
                    </div>
                  </>
                )}

                {detailData.referred_by === 2 && (
                  <div className="member-view-field member-view-field--full">
                    <span className="member-view-label">Referrer Name:</span>
                    <span className="member-view-value">
                      {checkEmptyOrNull(detailData.ref_member_name)} -{" "}
                      {checkEmptyOrNull(detailData.ref_member_region)} -{" "}
                      {checkEmptyOrNull(detailData.ref_member_chapter)}
                    </span>
                  </div>
                )}

                <div className="member-view-field">
                  <span className="member-view-label">Membership Status:</span>
                  <span className="member-view-value">
                    {checkEmptyOrNull(detailData.membership_status_text)}
                  </span>
                </div>
              </div>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn member-view-close-btn"
          onClick={onHide}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MemberDetailsModal;
